import counter from "./counter/reducer";
import { combineReducers } from "redux";

export default combineReducers({ counter });
